// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** Moldova */
const MD: PhoneNumberData = [373, 'MD', 8, '000 00 000'];

export default MD;
